import React from 'react'

import MUIDataTable from "mui-datatables";
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Divider from '@material-ui/core/Divider';
import NumberFormat from 'react-number-format';
import Checkbox from '@material-ui/core/Checkbox';
import SearchIcon from '@material-ui/icons/Search'
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import { ProductApi } from '../../api/product_api';
import Typography from '@material-ui/core/Typography';
import Notification from '../Notifications';


import { ADMIN_ROLE } from '../../constants'
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/user';
import { bindActionCreators } from 'redux';

const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };
  

const options = {
    selectedRows: {
        text: "fila(s) seleccionada",
        delete: "Delete",
        deleteAria: "Desactivar producto"
    },
    downloadOptions: {
        filename: 'Catalogo de Productos.csv',
        separator: ','
    },
    textLabels: {
        body: {
            noMatch: "No hay productos en catalogo",
            toolTip: "Sort",
        },
        pagination: {
            next: "Siguiente pag",
            previous: "Anterior",
            rowsPerPage: "Filas por pagina:",
            displayRows: "de",
        },
        toolbar: {
            search: "Buscar",
            downloadCsv: "Descargar CSV",
            print: "Imprimir",
            viewColumns: "Ver columnas",
            filterTable: "Filtrar tabla",
        },
        selectedRows: {
            text: "fila(s) seleccionadas",
            delete: "Desactivar",
            deleteAria: "Desactivar productos(s)",
          },
    
    },

}
const customStyles = {
    top: `30%`,
    margin: 'auto',
    width: 300,
    height: 400,
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};




function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            decimalScale={2}
            allowNegative={true}
            thousandSeparator={'.'}
            decimalSeparator={','}
            prefix="$"
        />
    );
}

const percentageLimit = (val)=> {
    if(val === 0){
        val = 1
    }else if(val >1000){
        val = 1000
    }else if(val < -1000){
        val = -1000
    }
    return val
}
function PercentageFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: percentageLimit(values.value),
                    },
                });
            }}
            decimalScale={2}
            allowNegative={true}
            thousandSeparator={'.'}
            decimalSeparator={','}
            suffix="%"
        />
    );
}

function mapStateToProps(state) {
    return {
        userRoles: state.user.userRoles

    };
}

function mapDispatchToProps(dispatch) {
    return {}
}


@connect(mapStateToProps, mapDispatchToProps)
export class StockView extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            columns: [{ name: "Codigo", options: { filter: false } },
            { name: "Status", options: { 
                print: false, 
                filterType: 'dropdown',
                filterList: ['Activo'],
                }
            },
            { name: "Tipo", options: { filterType: 'dropdown' } },
            { name: "Marca-Modelo", options: { filter: false } },
            { name: "Detalles", options: { filter: false, download: false, print: false,
                customBodyRender: _ => <SearchIcon /> } },
            { name: "Atributos", options: { filter: false, download: false, display: false, viewColumns: false, print: false} },
            { name: "Stock", options: { filter: false}},
            { name: "Precio", options: { 
                                display: true,
                                filter: false,
                                customBodyRender: value => <NumberFormat
                                    value={value}
                                    displayType={'text'}
                                    thousandSeparator={'.'}
                                    decimalSeparator={','}
                                    prefix="$"
                                />
                
                    
                }},
            
            ],
            
            title: "Catalogo de Productos",
            productCatalog: [],
            isLoading: true,
            targetProducts: [],
            productDetails: null,
            showDetails: false,
            amount: 0,
            stock:null,
            percentage: false,
            pricingError: false,
            showMsg: false,
            msgType: 'error', // success/error/warning
            msg: null


        },
       
        options['onCellClick'] = this.showProductDetails
        options['onRowsDelete'] = this.deactivateProducts
        options['onRowsSelect'] = this.appendCheckedList
    }
    showProductDetails = (a, b) =>{
        if(b.colIndex === 4){
            const targetProd = this.state.productCatalog[b.dataIndex]
            this.setState({ showDetails: true, productDetails: targetProd[5]})
        
        }
    }
    componentDidMount = () => {
       this.fetchCatalog()
    }

    fetchCatalog = () =>{
        ProductApi.getCatalogReport()
        .then((response) => {
            let rows = []
           
            response.data.map(function (obj) {
                let attrs = ''
                Object.keys(obj.attributes).map( (k ,v) => {
                    attrs += k + ':' + v + '  '
                });
                const active = obj.active?'Activo':'Inactivo';
                rows.push([obj.id, active, obj.type, obj.brand + '  ' + obj.model, obj.description, obj.attributes,  obj.stock, obj.price])
            })
            return rows
        })
        .then((data) => {
            this.setState({ productCatalog: data, isLoading: false })
        })
    }

    deactivateProducts = (rowsDeleted) => {
        const deleteProds = rowsDeleted.data.map((data) => {
            return this.state.productCatalog[data.dataIndex][0]
        });
        const data = {'active': false, 'products': deleteProds}
        ProductApi.updateCatalog(data)
        .then( response =>{
            this.setState({showMsg: true, msgType: 'success', msg:'Productos desactivados'})
            this.fetchCatalog()
        })
        .catch(error =>{
            console.log(error)
            this.setState({showMsg: true, msgType: 'error', msg:'No se pudo realizar la operacion'})
            
        })

    }
    appendCheckedList = (_, allRowsSelected) => {
        const tempTargetProducts = allRowsSelected.map((data) => {
            const prod =  this.state.productCatalog[data.dataIndex];
            return  {'prodId': prod[0], 'price': prod[7], 'stock': prod[6]}
        })
        this.setState({ targetProducts: tempTargetProducts })

    }

    updateCatalog = (e) => {
        e.preventDefault()
        this.hasChanged(true)
        
        const stockChanged = this.state.stock !='' && this.state.stock != null  && !isNaN(this.state.stock)
        const priceChanged =  this.state.amount !='' && this.state.amount != 0 && this.state.amount !=null && !isNaN(this.state.amount)
        if(priceChanged && !this.state.percentage && this.state.amount < 0){ // if raw amount, validate minimum
            if(this.state.targetProducts.every((prod, key) => (prod.price + this.state.amount) <= 0)){
                this.setState({showMsg: true, msgType: 'error', msg:'Precio invalido para uno o mas productos'})
                return;
            }
        }

        if(this.state.percentage && this.state.amount < -90){
            this.setState({showMsg: true, msgType: 'error', msg:'No se puede descontar mas del 90% de un precio'})
                return;
        }
        const modifiedProds = this.state.targetProducts.map(data =>{
            return  data.prodId
        })
        let data = {'products': modifiedProds}
        if(priceChanged){
            const action = this.state.percentage? 'percentage':'nominal'
            data['value'] =  this.state.amount;
            data['action'] =  action;

            if (action == 'nominal'){
                data['fixed'] = false
            }
        }
        if(stockChanged){
            if(this.state.targetProducts.every((prod, key) => (prod.stock + parseInt(this.state.stock)) < 0 )){
                this.setState({showMsg: true, msgType: 'error', msg:'Stock invalido para uno o mas productos'})
                return;
            }
            data['stock'] = parseInt(this.state.stock)
        }
        this.setState({isLoading: true})
        ProductApi.updateCatalog(data)
            .then(response => {
                this.hasChanged(true)
                this.setState({showMsg: true, msgType: 'success', msg:'Productos actualizados'})
                this.fetchCatalog()

            })
            .catch(error => {
                console.log(error)
                this.setState({showMsg: true, msgType: 'error', msg:'No se pudo realizar la operacion'})
            })

    }

    onCloseModal = (e) =>{
        this.setState({showDetails: false, productDetails: null})
    }

    switch = (e) => {
        this.setState({percentage: !this.state.percentage, amount:0})
    }

    setAmount = (e) =>{
        this.setState({amount: parseFloat(e.target.value)})
    }
    setStock = (e) =>{
        this.setState({stock:e.target.value})
    }
    hasChanged = (inUpdate) => {
        if(inUpdate){
            return true;
        }
        const stockChanged = this.state.stock !='' && this.state.stock != null  && !isNaN(this.state.stock)
        const priceChanged =  this.state.amount !='' && this.state.amount != 0 && this.state.amount !=null && !isNaN(this.state.amount)
        return (stockChanged || priceChanged) &&  this.state.targetProducts.length > 0
    }
    
    loadCatalog = () => {
        const isAdmin = this.props.userRoles.includes(ADMIN_ROLE)
        return (
            <div style={{ marginTop: 30 }}>
                <MUIDataTable
                    title={this.state.title}
                    data={this.state.productCatalog}
                    columns={this.state.columns}
                    options={options}
                />
                {isAdmin && <form role="form">

                    <FormGroup row >
                        <FormControl component="fieldset">
                            <RadioGroup aria-label="position" name="position"
                                value={this.state.percentage ? "%" : "$"}
                                onChange={this.creditCycle} row>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={this.state.percentage}
                                            onChange={this.switch}
                                            color="primary"
        
                                        />
                                    }
                                        label='Porcentual'
                                />


                            </RadioGroup>
                        </FormControl>
                    </FormGroup>
                    
                    <div className='col-md-4'>
                    <FormGroup row>
                    
                    <TextField
                            label={this.state.percentage?"Porcentaje":"Monto"}
                            value={this.state.amount}
                            onChange={this.setAmount}
                            id="amount"
                            InputProps={{
                                inputComponent: this.state.percentage?PercentageFormatCustom:NumberFormatCustom,
                            }}
                        />
                        
                    </FormGroup>
                    </div>
                    <div className='col-md-4'>
                        <FormGroup row>
                            <TextField
                                    label="Stock"
                                    value={this.state.stock}
                                    onChange={this.setStock}
                                    id="stock"
    
                                />
                        </FormGroup>
                    </div>
                    
                        <FormGroup row>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={(e) => this.updateCatalog(e)}
                            disabled={!this.hasChanged()}
                        >
                            Modificar
                        </Button>
                        {this.state.pricingError &&
                        <legend style={{color: red}}>Monto invalido: uno o varios productos
                        tienen un precio menor al descuento a aplicar</legend>}
                    </FormGroup>
                </form>}

            </div>
        )

    }

    getAttributes = () => {
        let attrs = []
        Object.entries(this.state.productDetails).map(([name, value]) => {
            if (typeof value === 'boolean') {
                value = value ? 'si' : 'no'
            }
            let newAttr = <Typography key={attrs.length} id={attrs.length} variant="subtitle1" gutterBottom>
                <b>{name}: </b> {value}
            </Typography>

            attrs.push(newAttr)
        })
        return attrs
    }
    handleClose = () => {
        this.setState({showMsg: false})
    }

    render() {
        
        let attributes = null;
        if(this.state.showDetails){
            attributes = this.getAttributes()
        }
        return (
            <div>
                {this.state.isLoading
                    ? <div style={{ marginTop: 70 }} className="col-md-6 col-md-offset-5">
                        <CircularProgress
                            size={80}
                            color='primary'
                            thickness={3}
                            style={{ display: 'center' }} />
                    </div>
                    : <div>{this.loadCatalog()}</div>
                }
                 <Modal
                style={customStyles}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={this.state.showDetails}
                onClose={this.onCloseModal}
                
            >
                <Paper elevation={4}>
                    <div style={{ marginTop: 20 }}  className='text-center'>
                        <div style={{  marginTop: 30 }}>
                            <Typography variant="h6" gutterBottom>
                                Descripcion del producto
                            </Typography>
                            <Divider/>
                            <div className='text-center'>
                            {attributes}
                            </div>
                        </div>
                    </div>
                </Paper>
            </Modal>
            <Notification
                    open={this.state.showMsg}
                    variant={this.state.msgType}
                    message={this.state.msg}
                    onClose={this.handleClose}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Logistic/StockView.js